import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '@aiwyn/config';

export const GUARD_DATA_CONFIG_ENABLED_FIELD = 'configEnabledField';
export const GUARD_DATA_CONFIG_REQUIRE_ALL = 'configRequireAll';

// Recasting to new names - eventually replace the above when entire app routing is refactored
export const CONFIG_GUARD_FIELDS = GUARD_DATA_CONFIG_ENABLED_FIELD;
export const CONFIG_GUARD_REQUIRE_ALL = GUARD_DATA_CONFIG_REQUIRE_ALL;
export const CONFIG_GUARD_REDIRECT_URL = 'configGuardRedirectUrl';
export const CONFIG_GUARD_INVERT = 'configGuardInvert';

export interface ConfigServiceRouteData {
  [CONFIG_GUARD_FIELDS]: string[]; // name of the config option(s) to check
  [CONFIG_GUARD_REDIRECT_URL]?: string[]; // route to navigate to when config options are insufficient
  [CONFIG_GUARD_INVERT]?: boolean; // true: navigation check is on "feature-disabled" or failure route
  [CONFIG_GUARD_REQUIRE_ALL]?: boolean; // true: all configs must be true, false: some config must be true
}

@Injectable({
  providedIn: 'root'
})
export class ConfigGuard {

  constructor(
    private readonly configService: ConfigService,
    private readonly router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const configs: (keyof ConfigService)[] = route?.data?.[GUARD_DATA_CONFIG_ENABLED_FIELD] ?? [];
    if (!configs.length) {
      console.error('Failed to find config for config guard. Please ensure that the name of the config is provided on the data of the route');
      return of(false);
    }

    return combineLatest(configs.map(config => this.configService.isConfigEnabled(config))).pipe(
      map(configValues => {
          let hasConfig = route?.data?.[GUARD_DATA_CONFIG_REQUIRE_ALL]
            ? configValues.every(config => config)
            : configValues.some(config => config);

          if (route?.data?.[CONFIG_GUARD_INVERT]) {
            hasConfig = !hasConfig;
          }

          if (hasConfig) {
            return true;
          }

          if (route?.data?.[CONFIG_GUARD_REDIRECT_URL]) {
            return this.router.createUrlTree(route?.data?.[CONFIG_GUARD_REDIRECT_URL]);
          }
          return false;
        }
      ),
    );
  }
}
